import { Route } from 'vue-router/types/router';
import { User } from '@run-diffusion/shared';
import type { FirebaseUser } from '@/firebase';
import { ROUTER } from '@/router/constants';
import { getPlatformHomePreference } from '@/utils';
import { TEAM_USER_ROLE_PERMISSION } from '@run-diffusion/shared';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';

export const shouldRedirectToLogin: Function = (route: Route, user: User): boolean => {
	return !!(
		route &&
		!user &&
		!route.meta.isLoginPage
	);
};

export const shouldRedirectToHome: Function = (route: Route, user: User): boolean => {
	return !!(
		user &&
		route?.meta.isInternalAdminPage &&
		!user.isAdmin
	);
};
export const shouldRedirectToUserNotActivated: Function = (route: Route, user: User): boolean => {
	return !!(
		route &&
		user &&
		(
			route.meta.isSessionPage ||
			route.meta.preventLaunchSession ||
			route.meta.isInternalAdminPage
		) &&
		!user.activatedAt
	);
};

export const shouldRedirectFromUserNotActivated: Function = (route: Route, user: User): boolean => {
	return !!(
		route &&
		user &&
		route.name === 'UserNotActivated' &&
		user.activatedAt
	);
};

export const shouldRedirectToEmailNotVerified: Function = (route: Route, authUser: FirebaseUser): boolean => {
	return !!(
		route &&
		authUser &&
		route.meta.emailVerifiedAuthRequired &&
		!authUser.emailVerified
	);
};

export const shouldRedirectFromEmailNotVerified: Function = (route: Route, authUser: FirebaseUser): boolean => {
	return !!(
		route &&
		authUser &&
		route.name === ROUTER.EMAIL_VERIFICATION &&
		authUser.emailVerified
	);
};

export const isRouteRunnitSideNavPage: Function = (route: Route, user: User) => {
	return !!(
		user &&
		route &&
		route.meta.isRunnitSideNavPage
	);
};

export const isRouteRunnitBoardPage: Function = (route: Route, user: User) => {
	return !!(
		user &&
		route &&
		route.name === ROUTER.RUNNITS_BOARD
	);
};

// Route to home based on platform preference and permissions
export const routeToHome: Function = (router: any, state: any, query: any): void => {
	const platformPreference: 'RD' | 'RUNNIT' = getPlatformHomePreference();

	// If preference is unset or RUNNIT, go to Runnit home
	if (!platformPreference || platformPreference === 'RUNNIT') {
		if (router.currentRoute?.path !== '/runnit') router.replace({ path: '/runnit/home', query });
		return;
	}

	// Default or RD preference: ensure user can USE_RD, otherwise route to Runnit
	const user = state?.user;
	const team = state?.team;
	const teamUserRole = state?.teamUserRole;

	// Admins can always go to RD home
	if (user?.isAdmin) {
		if (router.currentRoute?.path !== '/') router.replace({ path: '/', query });
		return;
	}

	const hasUseRdPermission: boolean = !!(
		state?.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.USER ||
		(
			state?.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM &&
			team?.id &&
			teamUserRole &&
			teamUserRole.teamId === team.id &&
			teamUserRole.roleDef?.permissions?.[TEAM_USER_ROLE_PERMISSION.USE_RD]
		)
	);

	if (hasUseRdPermission) {
		if (router.currentRoute?.path !== '/') router.replace({ path: '/', query });
	} else {
		if (router.currentRoute?.path !== '/runnit') router.replace({ path: '/runnit/home', query });
	}
};
